import {
  AgentStudioComponent,
  AgentStudioTemplate,
  SolutionPack,
  TemplateDatastore,
  ComponentType,
  IndexTargetWithModelIds,
  AgentConfiguration,
} from '../../../components/app-studio/agent-studio/interfaces';

// Active components that can be selected
export const activeComponents: AgentStudioComponent[] = [
  {
    name: 'Product Q&A',
    description:
      'Generates a conversational agent where users can ask questions about a product and get relevant answers',
    type: ComponentType.PRODUCT_QA,
    category: 'AI',
    enabled: true,
    datastoreCompatibilityType: 'QA_PAIR',
    cssOverrides: '',
    templateType: 'PRODUCT_QA',
    supportedComponentType: 'QA_PAIR',
    supportedCardType: 'QA_PAIR',
    filterParameter: 'productId',
  },
  {
    name: 'Conversational Q&A with FAQ',
    description:
      'Generates a conversational agent where users can ask questions about a product and get relevant answers',
    type: ComponentType.CONVERSATIONAL_QA_FAQ,
    category: 'AI',
    enabled: true,
    datastoreCompatibilityType: 'CONVERSATIONAL_QA_PAIR',
    cssOverrides: '',
    templateType: 'CONVERSATIONAL_QA',
    supportedComponentType: 'CONVERSATIONAL_QA_PAIR',
    supportedCardType: 'CONVERSATIONAL_QA_PAIR',
    filterParameter: 'productId',
  },
  {
    name: 'Conversational Q&A',
    description:
      'Generates a conversational agent where users can ask questions about a product and get relevant answers',
    type: ComponentType.CONVERSATIONAL_QA,
    category: 'AI',
    enabled: true,
    datastoreCompatibilityType: 'CONVERSATIONAL_QA',
    cssOverrides: '',
    templateType: 'CONVERSATIONAL_QA',
    supportedComponentType: 'CONVERSATIONAL_QA',
    supportedCardType: 'CONVERSATIONAL_QA',
    filterParameter: 'productId',
  },
  // Add other active components here
];

// Export the combined list for use in the app
export const components: AgentStudioComponent[] = [...activeComponents];

export const datastores: TemplateDatastore[] = [
  {
    id: '6ca7eee1-6527-4feb-bae8-e92ef95e073a',
    name: 'Manufacturing Product Q&A Datastore',
    type: 'QA_PAIR',
    indexTargetId: '2eb98ef3-6159-4a33-bc82-d526f19a5d91', // Reference to indexTargets[0].id
  },
  {
    id: '7db8fff2-7638-5gfc-cbf9-7029249174cb',
    name: 'Retail Product Q&A Datastore',
    type: 'QA_PAIR',
    indexTargetId: '3fa85f64-5717-4562-b3fc-2c963f66afa6', // Reference to indexTargets[1].id
  },
];

export const indexTargets: IndexTargetWithModelIds[] = [
  {
    id: '2eb98ef3-6159-4a33-bc82-d526f19a5d91',
    name: 'Manufacturing Product Q&A',
    solutionPackType: 'PRODUCT_QA',
    modelId: 'gemini-flash',
    domain: 'manufacturing',
    createdBy: 'user@example.com',
    creationDate: '2025-03-28T15:22:41.762Z',
    region: 'us-southcarolina-1',
  },
  {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'Retail Product Q&A',
    solutionPackType: 'PRODUCT_QA',
    modelId: 'llama-3-8b-instruct',
    domain: 'retail',
    createdBy: 'user@example.com',
    creationDate: '2025-03-28T15:25:12.108Z',
    region: 'us-southcarolina-1',
  },
  {
    id: '123',
    name: 'Conversational QNA',
    solutionPackType: 'PRODUCT_QA',
    conversationModelId: 'llama-3-8b-instruct',
    domain: 'retail',
    createdBy: 'user@example.com',
    creationDate: '2025-03-28T15:25:12.108Z',
    region: 'us-southcarolina-1',
  },
];
export const templates: AgentStudioTemplate[] = [
  {
    createdBy: 'foo@bar.com',
    creationDate: '2025-03-28T16:08:31.484640Z',
    lastModifiedBy: 'foo@bar.com',
    lastModified: '2025-03-28T16:08:31.484640Z',
    id: '9470a159-8d0f-40e8-872b-c39400d1b1f5',
    initialId: '9470a159-8d0f-40e8-872b-c39400d1b1f5',
    versionNumber: 0,
    type: 'PRODUCT_QA', // This should match component.templateType
    name: 'QA pair template',
    layout: {
      key: 'value',
    },
    datastoreQueries: [
      {
        id: '123e4567-e89b-12d3-a456-426614174002',
        name: 'dsq1',
        datastoreId: '6ca7eee1-6527-4feb-bae8-e92ef95e073a', // Reference to datastores[0].id
      },
    ],
    components: [
      {
        type: 'QA_PAIR', // This should match component.supportedComponentType
        id: '9b16cee1-3c63-4424-b972-6039138063ca',
        name: 'comp1',
        datastoreQueryId: '123e4567-e89b-12d3-a456-426614174002', // Reference to datastoreQueries[0].id
      },
    ],
  },
  {
    createdBy: 'foo@bar.com',
    creationDate: '2025-03-29T10:22:15.651324Z',
    lastModifiedBy: 'foo@bar.com',
    lastModified: '2025-03-29T10:22:15.651324Z',
    id: 'a581b26a-9e0f-51f9-983e-d4a500e2b2f6',
    initialId: 'a581b26a-9e0f-51f9-983e-d4a500e2b2f6',
    versionNumber: 0,
    type: 'PRODUCT_QA', // This should match component.templateType
    name: 'QA pair template 2',
    layout: {
      header: 'Product Questions',
      maxQuestionsDisplayed: 5,
    },
    datastoreQueries: [
      {
        id: '234f5678-f9ab-34e4-b567-537725285113',
        name: 'main-datasource',
        datastoreId: '7db8fff2-7638-5gfc-cbf9-7029249174cb', // Reference to datastores[1].id
      },
    ],
    components: [
      {
        type: 'QA_PAIR', // This should match component.supportedComponentType
        id: 'ac27dff2-4d74-5535-ca83-7148249174d7',
        name: 'question-answer-list',
        datastoreQueryId: '7db8fff2-7638-5gfc-cbf9-7029249174cb', // Reference to datastoreQueries[1].id
      },
    ],
  },
  {
    createdBy: 'foo@bar.com',
    creationDate: '2025-03-29T10:22:15.651324Z',
    lastModifiedBy: 'foo@bar.com',
    lastModified: '2025-03-29T10:22:15.651324Z',
    id: 'conversational-template-empty',
    initialId: 'conversational-template-empty',
    versionNumber: 0,
    type: 'CONVERSATIONAL_QA', // This should match component.templateType
    name: 'Conversational QnA',
    datastoreQueries: null,
    components: [
      {
        type: 'CONVERSATIONAL_QA', // This should match component.supportedComponentType
        id: 'ac27dff2-4d74-5535-ca83-7148249174d7',
        name: 'conversational-qna',
        agentConfigurationId: "agent-configuration-1",
      },
    ],
  },
  {
    createdBy: 'foo@bar.com',
    creationDate: '2025-03-29T10:22:15.651324Z',
    lastModifiedBy: 'foo@bar.com',
    lastModified: '2025-03-29T10:22:15.651324Z',
    id: 'cqa-faq-agent',
    initialId: 'cqa-faq-agent',
    versionNumber: 0,
    type: 'CONVERSATIONAL_QA_FAQ',
    name: 'Conversational QnA w/ FAQ',
    datastoreQueries: [{
      id: '7a4f5678-f9ab-34e4-b567-537725285114',
      datastoreId: '6ca7eee1-6527-4feb-bae8-e92ef95e073a',
      name: 'faq-datasource',
    }],
    components: [
      {
        type: 'CONVERSATIONAL_QA',
        id: 'ac27dff2-4d74-5535-ca83-7148249174d7',
        name: 'conversational-qna',
        agentConfigurationId: "agent-configuration-1",
      },
    ],
  },
];

export const AgentConfigurations: AgentConfiguration[] = [
  {
    agentType: ComponentType.CONVERSATIONAL_QA,
    id: 'agent-configuration-1',
    createdBy: 'user@lucidworks.com',
    creationDate: '2025-11-26T21:27:43.235888Z',
    lastModifiedBy: 'user@lucidworks.com',
    lastModified: '2025-11-26T21:27:43.548060Z',
    name: 'Conversational QnA Agent',
    indexTargetId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    conversationModelId: 'claude-3-5-sonnet',
    domain: 'retail',
  }
];

export const SolutionDomains = {
  parameter: 'domain',
  type: 'string',
  name: 'Domain for which Q&A is to be generated',
  allowedValues: [
    {
      value: 'manufacturing',
      name: 'Manufacturing',
    },
    {
      value: 'retail',
      name: 'Retail',
    },
    {
      value: 'hospitality',
      name: 'Hospitality',
    },
    {
      value: 'it-services',
      name: 'IT Services',
    },
    {
      value: 'tourism',
      name: 'Tourism',
    },
    {
      value: 'healthcare',
      name: 'Healthcare',
    },
    {
      value: 'finance-banking',
      name: 'Finance & Banking',
    },
    {
      value: 'other',
      name: 'Other',
    },
  ],
};

export const ConversationalQnAWithFAQSolutionPack: SolutionPack = {
  solutionPack: 'conversational-qa-faq',
  name: 'Conversational Q&A FAQ',
  parameters: [SolutionDomains],
  useCases: [
    {
      useCase: 'qa-generation',
      name: 'Product Q and A Generation',
      indexParameters: [
        {
          parameter: 'modelId',
          type: 'string',
          name: 'Model runs at index time and is optimized for relevant results',
          allowedValues: [
            {
              value: 'gemini-flash',
              name: 'Gemini Flash',
              modelProvider: 'Google',
              recommended: true,
            },
            {
              value: 'llama-3-8b-instruct',
              name: 'llama-3-8b-instruct',
              modelProvider: 'Lucidworks',
            },
          ],
        },
      ],
      queryParameters: [],
    },
    {
      useCase: 'qa-conversation',
      name: 'Conversation Generation',
      indexParameters: [
        {
          parameter: 'modelId',
          type: 'string',
          name: 'Model runs at query time and is optimized for speed',
          allowedValues: [
            {
              value: 'claude',
              name: 'claude',
              modelProvider: 'Lucidworks',
              recommended: true,
            },
            {
              value: 'gemini-flash',
              name: 'Gemini Flash',
              modelProvider: 'Google',
            },
            {
              value: 'llama-3-8b-instruct',
              name: 'llama-3-8b-instruct',
              modelProvider: 'Lucidworks',
            },
          ],
        },
      ],
      queryParameters: [],
    },
  ],
  preview: {
    showPreview: true,
  },
};

export const ConversationalQnASolutionPack: SolutionPack = {
  solutionPack: 'conversational-qa',
  name: 'Conversational Q&A',
  parameters: [
    {
      parameter: 'domain',
      type: 'string',
      name: 'Domain for which Conversational Q&A is to be generated',
      allowedValues: [
        {
          value: 'manufacturing',
          name: 'Manufacturing',
        },
        {
          value: 'retail',
          name: 'Retail',
        },
      ],
    },
  ],
  useCases: [
    {
      useCase: 'qa-conversation',
      name: 'Conversation Generation',
      queryParameters: [
        {
          parameter: 'conversationModelId',
          type: 'string',
          name: 'Model runs at query time and is optimized for speed',
          allowedValues: [
            {
              value: 'gemini-2.0-flash-lite',
              name: 'Gemini 2.0 Flash-Lite',
              modelProvider: 'Google Vertex AI',
              recommended: false,
            },
            {
              value: 'gemini-2.0-flash',
              name: 'Gemini 2.0 Flash',
              modelProvider: 'Google Vertex AI',
              recommended: false,
            },
            {
              value: 'claude-3-5-sonnet',
              name: 'Claude 3.5 Sonnet',
              modelProvider: 'Anthropic',
              recommended: true,
            },
            {
              value: 'gpt-4o-mini',
              name: 'GPT-4o mini',
              modelProvider: 'OpenAI',
              recommended: false,
            },
          ],
        },
      ],
    },
  ],
};

export const ProductQASolutionPack: SolutionPack = {
  solutionPack: 'product-qa',
  name: 'Product Q&A',
  parameters: [
    {
      parameter: 'domain',
      type: 'string',
      name: 'Domain for which Q&A is to be generated',
      allowedValues: [
        {
          value: 'manufacturing',
          name: 'Manufacturing',
        },
        {
          value: 'retail',
          name: 'Retail',
        },
      ],
    },
  ],
  useCases: [
    {
      useCase: 'qa-generation',
      name: 'Product Q&A Generation',
      indexParameters: [
        {
          parameter: 'modelId',
          type: 'string',
          name: 'GenAI model ID to use for generating Q&A',
          allowedValues: [
            {
              value: 'gemini-2.0-flash-lite',
              name: 'Gemini 2.0 Flash-Lite',
              modelProvider: 'Google Vertex AI',
              recommended: true,
            },
            {
              value: 'gemini-2.0-flash',
              name: 'Gemini 2.0 Flash',
              modelProvider: 'Google Vertex AI',
              recommended: false,
            },
            {
              value: 'claude-3-5-sonnet',
              name: 'Claude 3.5 Sonnet',
              modelProvider: 'Anthropic',
              recommended: false,
            },
            {
              value: 'gpt-4o-mini',
              name: 'GPT-4o mini',
              modelProvider: 'OpenAI',
              recommended: false,
            },
          ],
        },
      ],
    },
  ],
};

export const AISolutionPacks: SolutionPack[] = [ProductQASolutionPack, ConversationalQnAWithFAQSolutionPack, ConversationalQnASolutionPack];
